@use "~theme/typography";

.wearOption {
  height: 164px;
  border-radius: 8px;
  border: 4px solid var(--white);
  background-color: var(--white);
  outline: none;
  filter: drop-shadow(0 2px 4px var(--gray-01));
}

.wearOption:hover {
  border-color: var(--blue-01-at-30);
}

.wearOption:active {
  filter: drop-shadow(0 2px 6px var(--highlight-blue));
  border-color: var(--white);
}

.wearOption:focus-within {
  filter: drop-shadow(0 2px 6px var(--highlight-blue));
}

.wearOptionNameContainer {
  height: 68px;
  display: flex;
  padding-top: 4px;
}

.wearOptionName {
  @include typography.heading4;
  margin: auto;
}
